import { Checkbox, FormControlLabel } from "@mui/material";

export default function CheckboxComponent({
  propertyName,
  value,
  onValueChanged,
  text,
  isReadOnly,
}) {
  return (
    <FormControlLabel
      disabled={isReadOnly}
      size="small"
      name={propertyName}
      control={
        <Checkbox
          size="small"
          name={propertyName}
          checked={value}
          onChange={onValueChanged}
        />
      }
      label={<span style={{ fontSize: "12px" }}>{text}</span>}
    />
  );
}
